// extracted by mini-css-extract-plugin
export default {"label":"Form_label__HEXnZ"};